var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTestimonials(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 542,
    height: 380,
    viewBox: "0 0 542 380",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1065_3033",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 594,
    height: 380
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M593.534 0H0V379.169H593.534V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1065_3033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M389.178 207.627C416.814 207.627 439.218 185.219 439.218 157.577C439.218 129.935 416.814 107.527 389.178 107.527C361.542 107.527 339.139 129.935 339.139 157.577C339.139 185.219 361.542 207.627 389.178 207.627Z",
    fill: "#FFCDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.986 379.896C482.559 371.742 491.922 362.297 498.943 350.915C513.148 327.828 514.762 295.214 496.603 275.114C476.425 252.753 441.721 253.398 411.777 256.385C381.834 259.372 347.694 261.713 325.661 241.209C307.663 224.498 303.869 197.778 302.013 173.318C300.157 148.858 298.623 122.461 283.369 103.248C262.789 77.3354 221.466 74.2678 193.621 92.0275C165.776 109.868 151.249 144.015 150.926 177.032C150.764 191.159 151.652 208.192 139.949 216.184C130.668 222.561 117.835 219.413 107.827 214.246C97.8193 209.08 88.3763 201.895 77.2384 200.361C62.388 198.343 47.5375 207.385 39.3052 219.897C31.0729 232.41 28.4095 247.828 27.9252 262.843C26.6339 305.466 42.8564 347.928 70.8624 379.896H471.986Z",
    fill: "#FFCDCD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1065_3033",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 594,
    height: 380
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M593.534 0H0V379.169H593.534V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1065_3033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.8301 379.331H501.041",
    stroke: "#FCB0A4",
    strokeWidth: 1.0481,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.34 374.406H251.57C246.485 374.406 242.369 378.523 242.369 383.609H389.34V374.406Z",
    fill: "#F86E92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.973 312.651H338.656C335.992 312.651 333.652 314.266 332.603 316.687L306.291 378.281C305.242 380.784 307.099 383.609 309.843 383.609H408.308C410.971 383.609 413.312 381.994 414.361 379.573L439.461 320.804C441.076 316.929 438.251 312.651 433.973 312.651Z",
    fill: "#FF96BA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.659 349.462C383.206 355.355 377.234 360.199 371.342 360.199C365.45 360.199 361.818 355.436 363.271 349.462C364.724 343.569 370.696 338.725 376.588 338.725C382.48 338.725 386.112 343.569 384.659 349.462Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1065_3033",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 594,
    height: 380
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M593.534 0H0V379.169H593.534V0Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1065_3033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M470.938 162.985H252.62C242.773 162.985 234.783 170.977 234.783 180.826V273.741C234.783 283.59 242.773 291.582 252.62 291.582H336.557L351.569 306.597L366.581 291.582H470.857C480.704 291.582 488.694 283.59 488.694 273.741V180.826C488.775 170.977 480.784 162.985 470.938 162.985Z",
    fill: "white",
    stroke: "#F8968A",
    strokeWidth: 1.0481,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.775 217.563C292.264 213.566 296.717 202.631 292.721 193.14C288.725 183.649 277.793 179.195 268.303 183.192C258.814 187.189 254.361 198.123 258.357 207.614C262.353 217.106 273.285 221.56 282.775 217.563Z",
    fill: "#FFB8D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.442 183.409L317.832 193.661L328.728 193.58L320.011 200.038L323.401 210.291L314.604 203.994L305.887 210.452L309.196 200.119L300.318 193.823L311.214 193.742L314.442 183.409Z",
    fill: "#FA9B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.907 183.409L352.377 193.661L363.192 193.58L354.476 200.038L357.865 210.291L349.068 203.994L340.352 210.452L343.661 200.119L334.863 193.823L345.678 193.742L348.907 183.409Z",
    fill: "#FA9B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.368 183.409L386.838 193.661L397.653 193.58L388.937 200.038L392.407 210.291L383.529 203.994L374.893 210.452L378.122 200.119L369.324 193.823L380.139 193.742L383.368 183.409Z",
    fill: "#FA9B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.911 183.409L421.301 193.661L432.116 193.58L423.399 200.038L426.87 210.291L418.073 203.994L409.356 210.452L412.584 200.119L403.787 193.823L414.602 193.742L417.911 183.409Z",
    fill: "#FFC6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.374 183.409L455.764 193.661L466.579 193.58L457.943 200.038L461.333 210.291L452.536 203.994L443.819 210.452L447.047 200.119L438.25 193.823L449.065 193.742L452.374 183.409Z",
    fill: "#FFC6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.392 227.324H255.928V231.764H272.392V227.324Z",
    fill: "#F8968A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.125 227.324H276.428V231.764H301.125V227.324Z",
    fill: "#F8968A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.44 240.401H255.928V244.841H291.44V240.401Z",
    fill: "#FCC5BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.099 240.401H305.969V244.841H389.099V240.401Z",
    fill: "#FCC5BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.627 240.401H403.625V244.841H467.627V240.401Z",
    fill: "#FCC5BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.426 254.448H255.928V258.887H335.426V254.448Z",
    fill: "#FCC5BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.627 254.448H427.918V258.887H467.627V254.448Z",
    fill: "#FCC5BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.556 254.448H348.904V258.887H418.556V254.448Z",
    fill: "#FCC5BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.379 268.494H255.928V272.934H357.379V268.494Z",
    fill: "#FCC5BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.861 83.2283H333.409C326.952 83.2283 321.787 88.4754 321.787 94.8528V123.349C321.787 129.807 327.033 134.974 333.409 134.974H475.941C482.398 134.974 487.563 129.726 487.563 123.349V94.8528C487.563 88.4754 482.317 83.2283 475.861 83.2283Z",
    fill: "white",
    stroke: "#F8968A",
    strokeWidth: 1.0481,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.507 100.342L378.767 107.042H385.789L380.139 111.24L382.399 117.94L376.588 113.823L370.939 118.021L373.037 111.24L367.307 107.123H374.409L376.507 100.342Z",
    fill: "#FA9B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.025 100.342L401.285 107.042H408.307L402.657 111.24L404.917 117.94L399.106 113.823L393.456 118.021L395.555 111.24L389.824 107.123H396.927L399.025 100.342Z",
    fill: "#FA9B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.543 100.342L423.802 107.042H430.824L425.175 111.24L427.354 117.94L421.623 113.823L415.974 118.021L418.072 111.24L412.342 107.123H419.363L421.543 100.342Z",
    fill: "#FA9B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.062 100.342L446.241 107.042H453.344L447.694 111.24L449.873 117.94L444.143 113.823L438.493 118.021L440.592 111.24L434.861 107.123H441.883L444.062 100.342Z",
    fill: "#FA9B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.58 100.342L468.759 107.042H475.861L470.131 111.24L472.391 117.94L466.66 113.823L460.93 118.021L463.109 111.24L457.379 107.123H464.401L466.58 100.342Z",
    fill: "#FFC6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.713 108.547C358.63 102.869 354.772 97.523 349.096 96.6057C343.419 95.6884 338.074 99.5474 337.157 105.225C336.24 110.903 340.098 116.249 345.774 117.166C351.451 118.084 356.796 114.225 357.713 108.547Z",
    fill: "#FFB8D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.144 119.394H334.943V121.815H344.144V119.394Z",
    fill: "#F8968A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.206 119.394H346.404V121.815H360.206V119.394Z",
    fill: "#F8968A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.83 84.4392H114.93C110.491 84.4392 106.939 87.9911 106.939 92.4311V112.047C106.939 116.487 110.491 120.039 114.93 120.039H212.749C217.188 120.039 220.739 116.487 220.739 112.047V92.4311C220.82 87.9911 217.188 84.4392 212.83 84.4392Z",
    fill: "white",
    stroke: "#F8968A",
    strokeWidth: 1.0481,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.549 96.1444L146.083 100.746H150.925L147.051 103.652L148.585 108.253L144.63 105.428L140.756 108.253L142.209 103.652L138.254 100.827H143.096L144.549 96.1444Z",
    fill: "#FA9B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.046 96.1444L161.579 100.746H166.422L162.467 103.652L164.001 108.253L160.127 105.428L156.172 108.253L157.625 103.652L153.67 100.827H158.593L160.046 96.1444Z",
    fill: "#FA9B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.461 96.1445L176.995 100.746H181.837L177.963 103.652L179.497 108.253L175.542 105.428L171.668 108.253L173.121 103.652L169.166 100.827H174.009L175.461 96.1445Z",
    fill: "#FA9B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.958 96.1444L192.492 100.746H197.334L193.379 103.652L194.913 108.253L190.958 105.428L187.084 108.253L188.537 103.652L184.582 100.827H189.425L190.958 96.1444Z",
    fill: "#FA9B00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.373 96.1445L207.907 100.746H212.749L208.875 103.652L210.409 108.253L206.454 105.428L202.58 108.253L204.033 103.652L200.078 100.827H204.921L206.373 96.1445Z",
    fill: "#FFC6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.639 101.795C132.275 97.923 129.653 94.2689 125.782 93.6329C121.911 92.997 118.258 95.6199 117.622 99.4915C116.986 103.363 119.609 107.017 123.479 107.653C127.35 108.289 131.003 105.666 131.639 101.795Z",
    fill: "#FFB8D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.274 109.222H115.979V110.917H122.274V109.222Z",
    fill: "#F8968A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.332 109.222H123.889V110.917H133.332V109.222Z",
    fill: "#F8968A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1065_3033",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 594,
    height: 380
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M593.534 0H0V379.169H593.534V0Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1065_3033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190.715 89.1213L196.042 105.428H213.072L199.27 115.438L204.516 131.664L190.715 121.654L176.914 131.664L182.241 115.438L168.439 105.428H185.469L190.715 89.1213Z",
    fill: "#F8968A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.784 128.031L220.819 140.463H233.813L223.321 148.132L227.356 160.483L216.784 152.895L206.211 160.483L210.246 148.132L199.754 140.463H212.748L216.784 128.031Z",
    fill: "#F8968A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.753 165.649L202.094 172.915H209.681L203.547 177.355L205.887 184.539L199.753 180.099L193.619 184.539L195.96 177.355L189.826 172.915H197.413L199.753 165.649Z",
    fill: "#F8968A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.119 251.004C533.088 240.033 533.088 222.246 522.119 211.275C511.151 200.304 493.368 200.304 482.399 211.275C471.431 222.246 471.431 240.033 482.399 251.004C493.368 261.974 511.151 261.974 522.119 251.004Z",
    fill: "#F8968A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.049 217.314V227.001L507.742 231.522L488.049 236.042V245.81L524.529 231.522L488.049 217.314Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.554 63.0469C313.554 85.7308 295.153 104.217 272.635 104.136C249.794 104.056 233.894 86.6188 231.715 68.1326C230.262 55.943 233.572 45.045 241.642 35.8423C249.713 26.5588 260.206 21.796 272.554 21.796C294.91 21.796 313.635 39.9593 313.554 63.0469Z",
    fill: "#F8968A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.202 78.3848C274.57 78.3848 270.938 78.3848 267.306 78.3848C266.015 78.3848 265.531 77.9812 265.531 76.6896C265.612 71.0388 265.289 65.388 265.692 59.7372C265.934 56.1045 267.387 52.8755 269.647 49.9694C271.181 48.0319 272.714 46.0945 274.49 44.3993C275.055 43.8342 275.377 43.1884 275.377 42.3811C275.377 41.4124 275.458 40.4437 275.458 39.475C275.458 38.2641 275.862 37.2954 276.992 36.811C278.202 36.3267 279.332 36.5689 280.301 37.4569C281.269 38.3448 281.592 39.475 281.915 40.6859C282.641 43.7535 282.076 46.6596 280.866 49.4043C280.462 50.373 280.059 51.3417 279.574 52.2297C279.251 52.7948 279.494 53.0369 280.059 53.1177C280.301 53.1984 280.623 53.1177 280.866 53.1177C284.094 53.1177 287.403 53.1177 290.631 53.1177C292.407 53.1177 293.618 53.9249 294.021 55.4587C294.505 57.1539 293.779 59.0914 292.407 59.8986C291.761 60.2215 291.761 60.383 292.326 60.7866C293.537 61.5939 294.344 62.6433 294.102 64.2578C293.94 65.4687 293.295 66.276 292.165 66.6796C291.923 66.7603 291.6 66.7603 291.519 67.0025C291.439 67.3254 291.842 67.3254 292.003 67.4869C293.537 68.617 293.779 71.7653 291.519 72.734C291.116 72.8955 290.874 73.0569 291.358 73.4606C292.326 74.4293 292.407 75.6402 291.923 76.851C291.439 77.9812 290.47 78.3848 289.259 78.3848C285.466 78.3041 281.834 78.3848 278.202 78.3848Z",
    fill: "#FEDBDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.173 81.6138C258.187 81.6138 255.201 81.6138 252.215 81.6138C251.327 81.6138 250.923 81.1295 250.843 80.3222C250.762 79.9186 250.843 79.4342 250.843 79.0306C250.843 72.734 250.843 66.4374 250.843 60.2215C250.843 58.6877 251.246 58.2841 252.78 58.2841C255.443 58.2841 258.187 58.2841 260.85 58.2841C261.9 58.2841 262.465 58.7684 262.465 59.8178C262.465 66.4374 262.465 72.9762 262.465 79.5957V79.6764C262.303 79.7571 262.303 79.7571 262.465 79.8378C262.545 80.5644 262.465 81.2102 261.658 81.5331C261.658 81.3716 261.577 81.1295 261.335 81.2102C260.931 81.2102 261.173 81.4524 261.173 81.6138Z",
    fill: "#FEDBDE"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1065_3033",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 594,
    height: 380
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M593.534 0H0V379.169H593.534V0Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1065_3033)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.214 221.35C189.344 227.162 189.021 233.055 189.506 238.948C189.909 244.841 191.281 250.896 195.155 255.336C198.464 259.13 203.307 261.471 205.648 265.911C207.423 269.301 207.423 273.418 206.051 276.97C204.76 280.522 202.258 283.59 199.272 286.011C189.264 294.407 174.252 295.699 162.387 290.29C150.523 284.801 141.968 273.176 139.224 260.421C136.399 247.667 139.063 234.024 145.358 222.561C148.909 216.103 153.832 210.129 160.37 206.739C165.858 203.994 174.01 202.945 179.498 206.254C184.26 209.08 187.246 216.264 188.214 221.35Z",
    fill: "#452828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.722 352.53C282.722 352.53 280.623 357.131 275.135 354.386L271.584 361.086L280.462 365.769L286.919 353.66L284.417 341.712C284.417 341.712 281.995 342.681 282.076 345.264C282.076 347.767 282.722 352.53 282.722 352.53Z",
    fill: "#915046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.792 368.19C290.873 365.365 289.34 362.782 286.838 361.49L277.556 356.566L275.619 360.199L290.792 368.19Z",
    fill: "#994F39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.375 372.388C293.456 369.563 291.923 366.979 289.421 365.688L278.767 360.037L276.83 363.67L293.375 372.388Z",
    fill: "#AB6955"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.947 330.33L284.014 339.533H293.78L285.951 345.264L289.018 354.548L281.028 348.897L273.199 354.709L276.186 345.345L268.195 339.694L277.961 339.613L280.947 330.33Z",
    fill: "#FAAF3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.974 354.306L275.459 351.077L279.171 348.09C280.301 347.202 280.947 345.829 280.947 344.376V343.973L269.486 348.09L264.482 353.983L261.254 360.037L278.526 369.159L279.736 366.98C282.077 362.62 280.382 357.131 276.024 354.871L274.974 354.306Z",
    fill: "#B57A68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.713 375.698C290.794 372.872 289.261 370.289 286.759 368.998L276.105 363.347L274.168 366.979L290.713 375.698Z",
    fill: "#B57A68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.813 353.983C273.764 355.678 272.311 357.131 270.777 358.342",
    stroke: "#A15545",
    strokeWidth: 1.8647,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.99 353.902L265.613 354.79L265.37 361.974L202.74 371.581L212.99 353.902Z",
    fill: "#B57A68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.242 286.334H179.658C186.921 286.334 193.459 290.936 195.799 297.878L218.237 363.508C218.237 363.508 216.703 375.617 207.179 376.747C203.628 377.151 200.158 375.213 198.544 372.065L164.242 307V286.334Z",
    fill: "#383757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.387 352.852L254.153 354.548L237.446 375.698L205.324 377.635C201.047 377.877 197.818 373.922 198.867 369.805L200.966 361.813L203.387 352.852Z",
    fill: "#383757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.99 353.902C208.874 356.404 204.193 360.279 202.014 364.638",
    stroke: "#474463",
    strokeWidth: 1.8647,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.99 353.902C207.583 354.144 200.965 354.871 197.01 358.503",
    stroke: "#474463",
    strokeWidth: 1.8647,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.939 384.416L112.186 296.587L118.562 286.254H176.915L192.976 329.442C192.976 329.442 179.579 371.016 179.579 386.434L194.348 429.3L176.915 436L163.517 394.83L148.748 435.758L102.824 416.626L124.939 384.416Z",
    fill: "#474463"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.186 296.587L118.642 286.092H127.036L129.457 307L121.386 360.279L112.186 296.587Z",
    fill: "#383757"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.171 286.496V335.9L132.768 286.496H174.171Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.829 298.363C145.924 297.636 143.099 296.667 140.355 295.456L132.445 286.011H174.172V293.277C168.361 300.219 157.304 300.381 148.829 298.363Z",
    fill: "#B57A68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.445 286.092V316.929H150.121L140.355 337.676L175.463 337.434L132.445 286.092Z",
    fill: "#615F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.172 286.092H176.835L197.578 316.93H181.194L198.869 337.676H175.463H174.414L174.172 286.092Z",
    fill: "#615F7F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.413 337.676C170.459 356.485 167.472 375.617 163.518 394.426",
    stroke: "#383757",
    strokeWidth: 1.8647,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.457 286.011H114.042C106.778 286.011 100.241 290.613 97.9 297.555L75.4629 363.185C75.4629 363.185 75.705 368.029 77.9649 372.227C81.5161 378.846 90.3941 380.541 93.9453 373.922L129.457 306.758V286.011Z",
    fill: "#474463"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.925 356.566L155.203 360.198L165.372 362.539L165.292 362.136C165.13 360.683 164.242 359.472 163.032 358.665L160.449 356.646L161.175 353.821L165.453 350.269L160.288 345.829L149.23 353.095L150.925 356.566Z",
    fill: "#915046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.772 349.381L167.874 356.081L176.429 351.48L172.232 360.279L179.335 366.979L169.65 365.688L165.372 374.487L163.677 364.881L153.992 363.589L162.547 358.988L160.772 349.381Z",
    fill: "#FAAF3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.148 352.933C167.148 352.933 164.969 349.543 161.014 352.287L157.463 347.363L164.646 342.358L171.022 351.238L169.569 359.391C169.569 359.391 167.552 358.907 167.309 356.889C167.229 354.871 167.148 352.933 167.148 352.933Z",
    fill: "#915046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.41 357.373L147.213 351.722L162.87 339.613L164.323 341.632C167.229 345.668 167.067 349.3 164.565 351.238L161.176 353.902L151.41 357.373Z",
    fill: "#B57A68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.413 344.78C174.897 344.699 175.22 345.103 175.058 345.587C174.332 347.282 172.798 348.655 170.942 349.139L161.418 351.48L160.611 348.251L174.413 344.78Z",
    fill: "#B57A68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.121 331.299C173.605 330.976 174.251 331.218 174.251 331.864C174.332 334.205 173.363 336.465 171.426 337.999L161.983 345.587L159.4 342.358L173.121 331.299Z",
    fill: "#B57A68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.058 337.999C175.542 337.757 176.188 338.16 176.026 338.725C175.623 340.986 174.17 343.004 171.991 344.053L162.548 348.735L160.691 345.022L175.058 337.999Z",
    fill: "#B57A68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0074 349.946L143.823 349.623L127.681 372.146L87.5684 378.2C82.403 379.007 77.964 374.406 78.9325 369.24C80.3853 360.925 83.8558 350.592 92.0074 349.946Z",
    fill: "#474463"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.05 349.865L89.1016 350.269",
    stroke: "#383757",
    strokeWidth: 1.8647,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.05 349.865L88.375 354.548",
    stroke: "#383757",
    strokeWidth: 1.8647,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.613 244.76L144.47 290.371C144.55 292.227 146.084 293.68 147.859 293.68H170.296C173.121 293.68 174.413 290.29 172.476 288.352C168.198 284.155 163.84 276.889 163.84 264.942V245.729L142.613 244.76Z",
    fill: "#B57A68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.024 245.164L163.839 245.649V264.861C163.839 270.108 164.647 274.468 166.019 278.02C153.509 273.822 149.312 257.192 153.024 245.164Z",
    fill: "#915046"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.182 261.794C146.649 260.744 145.196 259.533 143.743 258.161C136.56 251.138 132.283 241.693 131.233 231.683C130.265 222.4 132.121 213.116 139.869 206.981C148.102 200.442 161.015 199.877 170.297 204.398C179.175 208.757 184.098 217.072 185.873 226.517C186.761 231.199 187.003 236.042 187.084 240.805C187.165 249.766 185.793 266.96 175.543 269.14C164.405 271.481 156.334 267.283 148.182 261.794Z",
    fill: "#B57A68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.643 222.642C185.629 226.839 186.437 232.167 187.244 237.253C189.1 230.714 189.1 223.691 187.244 217.152C186.356 214.085 185.064 211.098 182.966 208.757C180.868 206.416 177.801 204.721 174.653 204.801C169.649 204.882 163.677 211.744 168.842 215.861C170.375 217.152 173.039 216.829 174.895 217.395C178.043 218.121 180.787 219.897 182.643 222.642Z",
    fill: "#452828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.78 226.355C167.39 229.423 163.274 231.441 158.835 232.329C154.315 233.297 148.827 233.055 145.357 236.688C135.026 247.747 143.743 260.986 148.989 272.127C151.652 277.697 154.396 284.235 152.943 290.532C151.087 298.605 143.178 302.48 135.429 302.48C122.839 302.56 113.073 293.196 110.49 281.087C109.199 274.871 110.087 268.655 112.508 262.762C114.768 257.354 118.319 252.672 120.095 247.102C122.92 238.222 118.884 228.777 121.79 219.736C127.52 201.734 155.203 184.055 172.071 198.747C181.918 207.304 178.77 219.09 170.78 226.355Z",
    fill: "#452828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.003 230.311C143.743 232.49 142.291 235.477 141.968 238.626C141.564 242.178 142.533 245.729 144.308 248.878L146.649 248.474C146.891 244.438 147.94 240.402 149.151 236.607C149.716 234.831 150.442 233.136 151.249 231.441C150.604 228.293 148.102 228.373 146.003 230.311Z",
    fill: "#452828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.592 239.352C177.237 242.339 178.448 245.245 180.143 247.748C180.708 248.636 181.434 249.685 181.192 250.734C180.95 251.703 179.982 252.349 179.094 252.833",
    stroke: "#915046",
    strokeWidth: 1.2164,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.515 260.826C177.853 260.331 178.536 258.845 178.041 257.507C177.547 256.169 176.061 255.485 174.723 255.98C173.385 256.475 172.702 257.961 173.197 259.299C173.692 260.637 175.177 261.321 176.515 260.826Z",
    fill: "#FF7A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.497 256.95C176.834 258.565 173.444 258.726 170.619 257.515",
    stroke: "#915046",
    strokeWidth: 1.2164,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.55 231.199C183.291 229.907 180.869 230.23 179.094 232.087",
    stroke: "#452828",
    strokeWidth: 1.8231,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.633 233.54C164.405 232.49 161.015 233.055 158.352 235.074",
    stroke: "#452828",
    strokeWidth: 1.8231,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.067 240.563C167.31 241.774 166.422 242.985 165.211 243.227C164.001 243.469 162.79 242.581 162.548 241.37C162.306 240.159 163.193 238.948 164.404 238.706C165.695 238.545 166.906 239.352 167.067 240.563Z",
    fill: "#452828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.45 239.4C184.653 238.169 183.819 237.005 182.588 236.803C181.356 236.6 180.193 237.434 179.99 238.665C179.788 239.897 180.621 241.06 181.853 241.263C183.084 241.466 184.247 240.632 184.45 239.4Z",
    fill: "#452828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.823 243.388C142.289 242.097 140.029 241.37 138.173 242.097C136.639 242.742 135.59 244.195 135.187 245.81C134.783 247.424 135.106 249.12 135.59 250.653C137.366 255.578 142.289 259.21 147.454 259.453C148.504 259.533 147.939 250.815 147.777 250.008C147.374 247.586 145.679 245.003 143.823 243.388Z",
    fill: "#B57A68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.001 257.192C146.243 258.403 145.436 259.614 144.145 259.775C142.934 260.018 141.724 259.21 141.562 257.919C141.32 256.708 142.127 255.497 143.419 255.335C144.629 255.174 145.759 255.981 146.001 257.192Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.496 245.648C139.384 244.922 140.756 244.841 141.805 245.245C142.854 245.729 143.661 246.617 144.226 247.667C144.711 248.716 144.953 249.927 145.034 251.057C144.469 250.492 143.5 250.411 142.854 250.896C142.209 251.38 141.967 252.268 142.289 252.995C142.612 253.721 143.5 254.125 144.307 253.883",
    stroke: "#915046",
    strokeWidth: 1.2164,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestimonials);
export default __webpack_public_path__ + "static/media/testimonials.9d9ee97bbc070e0863a72ad66786a1d3.svg";
export { ForwardRef as ReactComponent };